import { InAppMessage } from "../../../../model/model"
import Evaluation from "../../../Evaluation"
import { InAppMessageLayoutEvaluateResult } from "./InAppMessageLayoutEvaluateResult"

export class InAppMessageLayoutEvaluation implements Evaluation {
  constructor(public readonly entity: InAppMessage, public readonly result: InAppMessageLayoutEvaluateResult) {}
}
